<div [ngClass]="{ grow: !showAddButton() }">
  <div class="bold">{{ evidence.evidenceDescription }}</div>
  <ng-container *ngIf="notCredential(); else isCredential">
    <div *ngIf="!evidence.evidenceValue.length">(empty)</div>

    <display-data
      *ngFor="let evidenceValue of evidence.evidenceValue"
      [value]="evidenceValue"
      [showAllFields]="showAllFields"
      [evidence]="evidence"
    >
      <button
        *ngIf="evidence.attributeUiType === 'Document'"
        mat-icon-button
        aria-label="Download button"
        (click)="openEvidenceImageInS3(evidenceValue, evidence)"
      >
        <mat-icon>download</mat-icon>
      </button>
    </display-data>
  </ng-container>

  <ng-template #isCredential>
    <display-data [value]="asCredential()" [showAllFields]="showAllFields" [evidence]="evidence"> </display-data>
  </ng-template>
</div>
<app-custom-field-editor-modal></app-custom-field-editor-modal>

<button
  *ngIf="showAddButton()"
  class="add-button"
  mat-button
  aria-label="Click to Add"
  (click)="openEditAttributeModal()"
>
  Click to Add
</button>
<button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Custom Fields actions" *ngIf="showEditButton()">
  <mat-icon>more_vert</mat-icon>
  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="openEditAttributeModal()">Edit Field</button>
    <button mat-menu-item (click)="onClearField()" *ngIf="canClear()">Clear Field</button>
  </mat-menu>
</button>
